import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { FLEET_QUERY_KEYS } from '~/constants/APIs/fleet'
import { fleetApis } from '~/api'
import { FleetFilterSelector } from './FleetFilterSelector'
import { CheckRole, fallbackFleetTreeData } from '~/utils'
import { useAppSelector } from '~/app/hooks'
import { USER_ROLE } from '~/constants/userRole'
import { selectFleetTree, setFleet, setFleetTree, selectAuth } from '~/redux/features'
import { useDispatch } from 'react-redux'
import { useLoaderData, useLocation } from 'react-router'
import { FleetButtonRouteData } from './FleetButton.model'

export const FleetNavButton = () => {
  const { roles } = useAppSelector(selectAuth)
  const dispatch = useDispatch()
  const fleetTree = useAppSelector(selectFleetTree)

  const location = useLocation()
  const loaderData = useLoaderData() as FleetButtonRouteData
  const [fleetTreeRouteDisabled, setFleetTreeRouteDisabled] = useState<boolean>(false)
  const [fleetTreeDisabled, setFleetTreeDisabled] = useState<boolean>(fleetTreeRouteDisabled)

  const fetchFleetTree = async () => {
    if (CheckRole([USER_ROLE.ADMIN, USER_ROLE.MAINTAINER, USER_ROLE.MANAGER, USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN], roles)) {
      try {
        const data = await fleetApis.getFleetTree()
        if (!data.id) {
          return fallbackFleetTreeData
        }
        return data
      } catch (error) {}
    }
    return fallbackFleetTreeData
  }

  const { data: fleetTreeData } = useQuery(
    [FLEET_QUERY_KEYS.GET_FLEET_TREE, location.pathname],
    () => fetchFleetTree()
  )

  useEffect(() => {
    if (fleetTreeData) {
      dispatch(setFleetTree(fleetTreeData))
      dispatch(
        setFleet({ fleetId: fleetTreeData.id, currentFleetName: fleetTreeData.name })
      )
    }
  }, [fleetTreeData, dispatch])

  //Determine the disabled state
  function disableBasedOnFleetTree(): boolean {
    //If the fallback tree is used then its either a permission denied or no data, either way disable it.
    return fleetTreeData === fallbackFleetTreeData
  }

  let shouldBeDisabled = false
  if (fleetTreeRouteDisabled || disableBasedOnFleetTree()) {
    shouldBeDisabled = true
  }

  if (shouldBeDisabled && !fleetTreeDisabled) {
    setFleetTreeDisabled(true)
  } else if (!shouldBeDisabled && fleetTreeDisabled) {
    setFleetTreeDisabled(false)
  }

  useEffect(() => {
    let newDisabledRoot = false
    if (loaderData?.fleetSelectorDisabled) {
      newDisabledRoot = true
    }
    if (newDisabledRoot !== fleetTreeRouteDisabled) {
      setFleetTreeRouteDisabled(newDisabledRoot)
    }
  }, [location, loaderData, fleetTreeRouteDisabled])
  //End Determine the disabled state

  

  return (
    <>
      {fleetTree && (
        <FleetFilterSelector
          rootFleet={fleetTree}
          disabled={fleetTreeDisabled}
        ></FleetFilterSelector>
      )}
    </>
  )
}
